// 書類作成で、開講前のユーザーグループを選んだまま書類を出そうとしたときに確かめる
// （対象の DL ボタンに data-before-open-confirm を付ける。参考様式11・A-20-2 は開講前だと受講時間が空欄になる）
document.addEventListener('DOMContentLoaded', function() {
    const hiddenInput = document.getElementById('user_group_input');

    if (!hiddenInput) return;

    document.querySelectorAll('[data-before-open-confirm]').forEach(button => {
        button.addEventListener('click', function(event) {
            // 選択中のユーザーグループの開講ステータス（一覧に無いユーザーグループを選択中のこともあるため hidden に持つ）
            if (hiddenInput.dataset.statusKey !== 'before_open') return;

            if (!window.confirm('開校前ですが、ダウンロードしますか？')) {
                event.preventDefault();
            }
        });
    });
});
